<div class="breadcrumb-area">
	<h1>Configuración de Lista de Precio por Ubicación</h1>
</div>
<div class="card mb-5">
	<div class="card-header">
		<h3>Lista de Precios por Ubicación</h3>
	</div>
	<div class="card-body">
        <div class="row mb-3">
            <!-- <div class="col-6">
                <div class="form-group">
                    <label for="pricelist" class="form-label">Ubicación</label>
                    <select name="pricelist" id="pricelist" (change)="changingPlace()" [(ngModel)]="placeSelectedId"
                        class="form-select">
                        <option value="{{-1}}">Todas</option>
                        <option *ngFor="let item of allPlaces" value="{{item.id}}">{{item.name}}</option>
                    </select>
                </div>
            </div> -->
            <div class="col-6">
                <div class="form-group">
                    <label for="pricelist" class="form-label">Familia</label>
                    <select name="pricelist" id="pricelist" (change)="changingCategory()" [(ngModel)]="categorySelectedId"
                        class="form-select">
                        <!-- <option value="-1">Buscar Ubicación</option> -->
                        <option value="{{-1}}">Todas</option>
                        <option *ngFor="let item of allCategories" value="{{item.id}}">{{item.name}}</option>
                    </select>
                </div>
            </div>
        </div>

        <div class="row mb-3">
            <div class="col-6">
                <div class="form-group">
                    <label for="pricelist" class="form-label">Buscar de Lista</label>
                    <select name="pricelist" id="pricelist" (change)="changingPriceList()" [(ngModel)]="priceListSelectedId"
                        class="form-select">
                        <option value="-1" disabled>Selecciona una lista de precios</option>
                        <option *ngFor="let item of allPriceList" value="{{item.id}}">{{item.name}}</option>
                    </select>
                </div>
            </div>
        </div>

		
		<ng-container *ngIf="priceListSelectedId != -1">
            <div class="row mb-3">
                <table class="table table-hover table-bordered tabla-ubicaciones">
                    <thead>
                        <tr class="text-left">
                            <th class="">
                                <!-- <span class="texto-columnas">Ubicación</span>
                                <span class="texto-filas">Familia</span> -->
                                Familia
                            </th>

                            <ng-container *ngFor="let item of pricesList">
                                <th class="text-center bg-primary-subtle">
                                    {{ item.placeName }}
                                </th>
                            </ng-container>
                        </tr>
                    </thead>

                    <tbody *ngIf="categoriesRows">
                        <ng-container *ngFor="let item of categoriesRows">
                            <tr>
                                <td class=" bg-warning-subtle">
                                    <strong>
                                        {{item.categoryName}}
                                    </strong>
                                </td>
                                <ng-container *ngFor="let itemPriceList of pricesList">
                                    <td class="text-center">
											<div class="profit-margin">
												<span *ngIf="editFamily[item.categoryId + '_' + itemPriceList.id] == undefined"
													(click)="editProfitFamily(item.categoryId + '_' + itemPriceList.id)"
													class="profit-ammount">{{profitItem[item.categoryId + '_' + itemPriceList.id].profitPercentage}}% <i
														class="fa fa-edit"></i></span>
												<div *ngIf="editFamily[item.categoryId + '_' + itemPriceList.id] != undefined"
													class="input-group input-group-sm">
													<label for="profit" class="input-group-text">%</label>
													<input style="text-align: center;" type="number" name="profit"
														[(ngModel)]="editFamily[item.categoryId + '_' + itemPriceList.id]" id="profit"
														class="form-control" min="0">
													<button class="btn btn-success" 
														[disabled]="profits[item.categoryId + '_' + itemPriceList.id] == editFamily[item.categoryId + '_' + itemPriceList.id] || editFamily[item.categoryId + '_' + itemPriceList.id] <= 0 || loading[item.categoryId + '_' + itemPriceList.id]" 
														(click)="saveProfitOfSingleCategory(item.categoryId, itemPriceList.id, editFamily[item.categoryId + '_' + itemPriceList.id])"
                                                        >
														<ng-container *ngIf="!loading[item.categoryId + '_' + itemPriceList.id]">
															<i class="fa fa-floppy-disk"></i>
														</ng-container>
														<ng-container *ngIf="loading[item.categoryId + '_' + itemPriceList.id]">
															<span class="spinner-border spinner-border-sm"
																aria-hidden="true"></span>
															<span role="status"></span>
														</ng-container>
													</button>
												</div>
											</div>
										</td>
                                </ng-container>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>
            </div>
		</ng-container>
        
	</div>
</div>
<!-- <button class="btn btn-success btn-hide" (click)="saveAllProfits()" *ngIf="getShowSaveChanges()"
	[disabled]="getLoadingChanges()">
	<ng-container *ngIf="!savingAll">
		<i class="fa fa-floppy-disk"></i>
	</ng-container>
	<ng-container *ngIf="savingAll">
		<span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
		<span role="status"></span>
	</ng-container>GUARDAR TODO
</button> -->